import React, { useEffect, useState } from "react";
import { Button, SideSheet, Tooltip } from "@douyinfe/semi-ui";
import { IconHelpCircle } from "@douyinfe/semi-icons";
import { useLocation } from "react-router-dom";
import { Manual, ManualApi } from "../pages/manual/api";

// 操作手册按路由匹配 DB 中的 slug；未匹配则隐藏入口
export function PageManual() {
  const [visible, setVisible] = useState(false);
  const [manual, setManual] = useState<Manual | null>(null);
  const [status, setStatus] = useState<"loading" | "found" | "notFound">(
    "loading"
  );
  const location = useLocation();

  useEffect(() => {
    const routeKey = location.pathname.replace(/^\//, "");
    if (!routeKey) {
      setStatus("notFound");
      setManual(null);
      return;
    }

    let cancelled = false;
    ManualApi.get(routeKey)
      .then((result) => {
        if (cancelled) return;
        if (result) {
          setManual(result);
          setStatus("found");
        } else {
          setManual(null);
          setStatus("notFound");
        }
      })
      .catch((err) => {
        console.warn("[PageManual] lookup failed:", err);
        if (cancelled) return;
        setManual(null);
        setStatus("notFound");
      });

    return () => {
      cancelled = true;
    };
  }, [location.pathname]);

  if (status !== "found" || !manual) {
    return null;
  }

  const renderUrl = `/api/mis/manual/render/${manual.id}`;

  return (
    <>
      <Tooltip content="操作手册" position="leftTop">
        <Button
          icon={<IconHelpCircle />}
          theme="solid"
          type="warning"
          size="large"
          style={{
            position: "fixed",
            right: 24,
            bottom: 80,
            zIndex: 1000,
            borderRadius: "50%",
            width: 48,
            height: 48,
            boxShadow: "0 4px 12px rgba(255, 136, 0, 0.4)",
          }}
          onClick={() => setVisible(true)}
        />
      </Tooltip>
      <SideSheet
        title={
          <span style={{ fontSize: 16, fontWeight: 600 }}>操作手册</span>
        }
        visible={visible}
        onCancel={() => setVisible(false)}
        width="70%"
        placement="right"
        bodyStyle={{ padding: 0 }}
        style={{ height: "100%" }}
      >
        <iframe
          src={renderUrl}
          style={{
            width: "100%",
            height: "calc(100vh - 86px)",
            border: "none",
          }}
          title="操作手册"
        />
      </SideSheet>
    </>
  );
}
